(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miron-custom-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MQ = window.matchMedia('(max-width: 749px)');

  function attachAccordion(footer) {
    var toggles = footer.querySelectorAll('[data-mcf-accordion] .mcf__col-toggle');
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!MQ.matches) return;
        var expanded = this.getAttribute('aria-expanded') === 'true';
        var targetId = this.getAttribute('aria-controls');
        var target = document.getElementById(targetId);
        if (!target) return;
        this.setAttribute('aria-expanded', String(!expanded));
        target.classList.toggle('mcf--open', !expanded);
      });
    });
  }

  function init() {
    var footer = document.getElementById('mcf-footer');
    if (footer) attachAccordion(footer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
